.ContextMenuItem,
.ContextMenuItemDisabled {
  color: var(--context-menu-item-color, #fff);
  font-family: var(--context-menu-font-family, sans-serif);
  font-size: var(--context-menu-item-font-size, 16px);
  padding: var(--context-menu-item-padding, 0.25rem 1rem);
  user-select: none;
  display: flex;
  align-items: center;
  gap: 1ch;
  min-height: var(--context-menu-item-height);
  transition: color var(--context-menu-transition-duration, 250ms),
    background-color var(--context-menu-transition-duration, 250ms);
}
.ContextMenuItem {
  cursor: pointer;
}

.ContextMenuItemDisabled {
  background-color: var(--context-menu-item-background-color-disabled);
  color: var(--context-menu-item-color-disabled, rgba(255, 255, 255, 0.25));
}

.ContextMenuItem:hover {
  transition: background-color 250ms;
  background-color: var(
    --context-menu-item-background-color-hover,
    rgba(255, 255, 255, 0.1)
  );
  color: var(
    --context-menu-item-color-hover,
    var(--context-menu-item-color, #fff)
  );
}

.ContextMenuItem:focus {
  outline: none;
  background-color: var(
    --context-menu-item-background-color-focus,
    rgba(255, 255, 255, 0.1)
  );
  color: var(
    --context-menu-item-color-focus,
    var(--context-menu-item-color, #fff)
  );
}
